import {
    IsmetApps, LangSwitcher, ReCaptcha, Footer, Auth,
    Dialog, Share, ImageCropper, ColorPicker, installI18nMessages, Calendar, Logo,
    SiteFooter, PayWidget, AppHeader, KtCallback, MobileDownload
} from '@ismet/vue-ui-kit'
import {apiForClient} from "~/composables/useApi.js";

export default defineNuxtPlugin((nuxtApp) => {
    // В Nuxt .client.js плагинах объект window уже доступен
    const app = nuxtApp.vueApp
    const i18n = nuxtApp.$i18n

    // Установка сообщений
    installI18nMessages(i18n)

    // Регистрация компонентов
    app.component('IsmetApps', IsmetApps)
    app.component('LangSwitcher', LangSwitcher)
    app.component('ReCaptcha', ReCaptcha)
    app.component('FooterKit', Footer)
    app.component('AuthKit', Auth)
    app.component('DialogKit', Dialog)
    app.component('ImageCropper', ImageCropper)
    app.component('ShareKit', Share)
    app.component('ColorPicker', ColorPicker)
    app.component('CalendarKit', Calendar)
    app.component('SiteFooter', SiteFooter)
    app.component('LogoKit', Logo)
    app.component('PayWidget', PayWidget)
    app.component('AppHeader', AppHeader)
    app.component('KtCallback', KtCallback)
    app.component('MobileDownload', MobileDownload)

    // Прокидываем api
    app.provide("api", apiForClient)
})
